import { Building2 } from 'lucide-react';
import { EncabezadoDePagina } from '@/shared/ui/EncabezadoDePagina';
import { PanelDeRecaudacion } from './PanelDeRecaudacion';

export function PaginaRecaudacionDeCooperativas() {
  return (
    <>
      <EncabezadoDePagina
        icono={Building2}
        color="indigo"
        titulo="Recaudación de cooperativas"
        subtitulo="Lo que cobraron por nosotros · para cuadrar su liquidación"
      />

      <PanelDeRecaudacion />
    </>
  );
}
